import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData } from '@components/ssap/SsapTypes';

interface IAgreeToFileAttestation {
  actions: {
    onFieldChange_data: Function
  },
  data: SsapData,
  formName: string
}

const AgreeToFileAttestation = (props: IAgreeToFileAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                aptcAgreementIndicator
            }
        },
        formName
    } = props;

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <span className = 'required-true'>
                            <FormattedMessage id = 'ssap.input.label.agree_to_file_taxes' />
                        </span>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'aptcAgreementIndicator',
                classes: [ 'disp-styl' ],
                checked: aptcAgreementIndicator,
                value: aptcAgreementIndicator,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default AgreeToFileAttestation;